/* RESPONSIBLE TEAM: team-standalone */
import Model, { attr } from '@ember-data/model';

export default class ExternalAgent extends Model {
  @attr('string') declare name: string;
}
